import { styled } from "../../../styled-components";
import { css } from "styled-components";

const inlineProps = css`
    padding-bottom: 100%;
    overflow: hidden;
`;

export const MapListStyle = styled.div<{ isInline: boolean; isMapMode: boolean }>`
    position: relative;
    width: 100%;
    flex-grow: 1;
    ${p => p.isInline && p.isMapMode && inlineProps}
`;

const fabOpen = css`
    transform: translateY(-86px);
    transition-timing-function: cubic-bezier(0.17, 0.62, 0.37, 1.36);
`;

const fabClosed = css`
    transform: translateY(0);
    transition-timing-function: ease-in-out;
`;

export const ListWrapper = styled.div<{ isInline: boolean }>`
    padding-bottom: ${p => (p.isInline ? 0 : 86)}px;
`;

export const FloatingButtonWrapper = styled.div<{ bottomOpen: boolean }>`
    color: ${p => p.theme.baseColor};

    & > * {
        ${p => (p.bottomOpen ? fabOpen : fabClosed)};

        transition-property: transform;
        transition-duration: 0.3s;
    }
`;

export const BottomListItemWrapper = styled.div<{ show: boolean }>`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background-color: ${p => p.theme.baseColor};

    @keyframes bottom-list-item-intro {
        0% {
            transform: translateY(100%);
        }
        50% {
            transform: translateY(100%);
        }
        100% {
            transform: translateY(0);
        }
    }

    @keyframes bottom-list-item-outro {
        0% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(100%);
        }
        100% {
            transform: translateY(100%);
        }
    }

    ${p => !p.show && `transform: translateY(100%);`};

    animation: ${p => (p.show ? "bottom-list-item-intro" : "bottom-list-item-outro")} 0.3s;
    animation-timing-function: ease-out;
`;
